import type { BrandFilterPickerProps } from './useBrandFilterPicker';
import { useBrandFilterPicker } from './useBrandFilterPicker';
import { BrandFilterPickerView } from './BrandFilterPickerView';

/** Searchable multi-select: No brand, known brands, and removable unknown ids. */
export const BrandFilterPicker = ({
    options,
    value,
    onChange,
}: BrandFilterPickerProps) => {
    const picker = useBrandFilterPicker(options.items, value, onChange);
    return <BrandFilterPickerView options={options} picker={picker} />;
};
